export default function Services() {
    return <div>Services</div>;
}
